import { Auth } from "../domain/models/auth.model";

export const login: Auth = {
  token: 'eyJraWQiOiJkMFZGSD...',
  idCommerce: 3,
  idFranchise: 2,
  idRole: 2, // 2
  uidCms: 'uidCMSTest',
  userName: 'PruebaLeal', // "servcliente.430"
  name: 'PruebaAlguien', //"Servicio al Cliente Leal"
  commerceName: 'TexacoTest',
  idPlan: 'Pro',
  countryCode: 'CO', // "CO"
  platform: 'CAP', // "CAP"
  imageCommerceUrl:
    '/fit-in/306x205/images/logos/eccbc87e4b5ce2fe28308fd9f2a7baf3.jpg?v=1612277453',
  baseUrl: 'https://img.leal.co',
  categoryName: 'Gasolinera',
  roleName: 'Admin',
  commerceType: 'puntos',
  idBranch: '1',
};

export const loginError = {
  message: 'La solicitud no es válida',
  error: 'Credenciales invalidas',
};
